<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="基本信息"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
<!--            <template #right>-->
<!--                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>-->
<!--            </template>-->
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <div style="margin: 10px 0px">
                <van-notice-bar color="#1989fa" background="#ecf9ff">
                    服务商信息
                </van-notice-bar>
                <van-cell title="服务商编号" :value="list.agent_num"/>
                <van-cell title="服务商名称" :value="list.name"/>
                <van-cell title="负责人姓名" :value="list.name"/>
                <van-cell title="负责人手机号" :value="list.tel"/>
<!--                <van-cell title="商户类型"   :value="bb"/>-->
<!--                <van-cell title="商户营业执照名" :value="list.bse_lice_nm"/>-->
            </div>
            <!--身份信息 start-->
            <div v-if="form.agent.agent_type == 0">
                <van-notice-bar color="#1989fa" background="#ecf9ff">
                    费率信息
                </van-notice-bar>
                <van-cell title="D1成本费率" :value="list.d1_cost"/>
                <van-cell title="D1终端费率" :value="list.d1_term"/>
                <van-cell title="D0成本费率" :value="list.d0_cost"/>
                <van-cell title="D0终端费率" :value="list.d0_term"/>
                <van-cell title="银联大于1000成本费率" :value="list.unionscan_cost"/>
                <van-cell title="银联大于1000终端费率" :value="list.unionscan_term"/>
            </div>
            <!--身份信息 end-->
            <!--我的银行卡 start-->
            <div style="margin-top: 10px">
                <van-notice-bar color="#1989fa" background="#ecf9ff">
                    结算信息
                </van-notice-bar>
                <van-cell title="结算卡开户支行" :value="list.banks.s_khh"/>
                <van-cell title="结算账户" :value="list.banks.s_hm"/>
                <van-cell title="结算账号" :value="list.banks.s_kh"/>
            </div>
            <!--我的银行卡 end-->
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    export default {
        name: "BasicInformation", //基本信息
        data(){
            return{
                form:{},
                list:[],
                aa:'',
                bb:""
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/MyAgent');
            },
            // // 右侧icon跳转至商户首页
            // onClickRight() {
            //     // 返回商户首页
            //     this.$router.push('/MerchantHomepage');
            // },
            //初始化页面
            Basic(){
                this.$http.get('/wechat/api.agent.index/getProfile').then(response => {
                    this.list=response.data.data
                    this.Card()
                    this.Cards()

                })
            },
            theMerchants() {
            this.$http.get('/wechat/api.agent.index/info').then(response => {
                this.form = response.data.msg
            })
        },
            // 判断卡类型
            Card(){
                if (this.list.settlement_account_type=="01") {
                    this.aa="法人账户"
                }else if(this.list.settlement_account_type=="00"){
                    this.aa="对公账户"
                }else if(this.list.settlement_account_type=="02"){
                    this.aa="被授权人"
                }
            },
            //判断商户类型
            Cards(){
                if (this.list.merchant_type=="1") {
                    this.bb="个体"
                }else if(this.list.merchant_type=="2"){
                    this.bb="企业"
                }else if(this.list.merchant_type=="3"){
                    this.bb="小微"
                }
            }
        },
        mounted(){
            this.Basic()
            this.theMerchants()
        }
    }
</script>

<style scoped>
    .content_title{
        font-size: 18px;
    }
</style>
